module.exports = __webpack_public_path__ + "img/IHPBA20-Virtual-banner.554017f7.jpg";